import moment from 'moment';
var DateValidation = /** @class */ (function () {
    function DateValidation() {
    }
    DateValidation.validate = function (control) {
        if (!control.value) {
            return null;
        }
        var valueAsMoment = moment(control.value);
        var isValidDate = valueAsMoment.isValid();
        var isYearGtZero = valueAsMoment.year() > 0;
        if (isValidDate && isYearGtZero) {
            return null;
        }
        return {
            invalidDate: true
        };
    };
    return DateValidation;
}());
export { DateValidation };
